export type Therapist = {
  slug: string
  name: string
  origin: string
  /** Slug of the studio this therapist is usually based at. */
  locationSlug: string
  experience: string
  languages: string[]
  specialties: string[]
  tagline: string
  bio: string
  image: string
}

export const THERAPISTS: Therapist[] = [
  {
    slug: 'mei',
    name: 'Mei',
    origin: 'Taiwan',
    locationSlug: 'hendra-magic-massage-spa',
    experience: '8 years',
    languages: ['English', 'Mandarin'],
    specialties: ['Deep tissue', 'Shoulder & neck', 'Acupressure'],
    tagline: 'Finds the knot you forgot about.',
    bio: 'Mei trained in Taipei and has spent the last eight years working with desk-bound clients. She reads tension quickly and works methodically through the shoulders, neck and upper back — firm when you want it, never rushed.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/ee48cd0f-1d00-4b2e-8435-e34d8813058d.jpg',
  },
  {
    slug: 'lin',
    name: 'Lin',
    origin: 'China',
    locationSlug: 'delightful-day-spa-massage',
    experience: '10 years',
    languages: ['English', 'Mandarin', 'Cantonese'],
    specialties: ['Deep tissue', 'Sports recovery', 'Reflexology'],
    tagline: 'Ten years of very strong hands.',
    bio: 'Lin is our most requested deep tissue therapist. A decade of practice has given her the strength and precision to work through stubborn tightness without ever losing the calm, steady rhythm that keeps you relaxed.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/96b70cfd-d13b-4a8f-bb71-ffc6d001e07d.jpg',
  },
  {
    slug: 'nana',
    name: 'Nana',
    origin: 'Malaysia',
    locationSlug: 'dream-day-spa-massage',
    experience: '6 years',
    languages: ['English', 'Malay'],
    specialties: ['Relaxation', 'Aromatherapy', 'Full body'],
    tagline: 'Warm oil, slow hands, zero rush.',
    bio: "Nana's sessions are all about the wind-down. Warm oil, long flowing strokes and a pace that lets your shoulders drop before she has even reached them. Ask her about the aromatherapy blends she mixes herself.",
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/95a18976-0c79-48ab-8e71-91fd176e75ad.jpg',
  },
  {
    slug: 'yumi',
    name: 'Yumi',
    origin: 'Japan',
    locationSlug: 'vip-magic-massage',
    experience: '7 years',
    languages: ['English', 'Japanese'],
    specialties: ['Shiatsu', 'Relaxation', 'Head & scalp'],
    tagline: 'Quiet, precise, unhurried.',
    bio: 'Trained in shiatsu in Osaka, Yumi works with focused pressure along the meridian lines. Clients describe her sessions as the closest thing to falling asleep standing up — especially her head and scalp work.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/efbaf5be-5058-463d-8ac1-28c64596d9be.jpg',
  },
  {
    slug: 'kim',
    name: 'Kim',
    origin: 'Korea',
    locationSlug: 'rocklea-magic-massage',
    experience: '9 years',
    languages: ['English', 'Korean'],
    specialties: ['Deep tissue', 'Lower back', 'Stretching'],
    tagline: 'The one to see about your lower back.',
    bio: 'Kim combines deep tissue work with assisted stretching, which makes her the go-to for tradies and anyone who spends the day lifting. Firm, confident pressure and a genuinely warm bedside manner.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/5a567d0d-4b8a-4564-90bd-1a9506f05fe5.jpg',
  },
  {
    slug: 'ploy',
    name: 'Ploy',
    origin: 'Thailand',
    locationSlug: 'mimi-massage-nerang',
    experience: '11 years',
    languages: ['English', 'Thai'],
    specialties: ['Traditional Thai', 'Stretching', 'Relaxation'],
    tagline: 'Traditional Thai, the way it should be.',
    bio: 'Ploy learned traditional Thai massage in Chiang Mai and has been practising for over a decade. Expect rhythmic compression, gentle stretching and the kind of full-body release you only get from someone who was taught properly.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/a0e70e23-90ff-41f0-b5ea-a8449879897a.jpg',
  },
]

export const THERAPISTS_HERO =
  'https://cdn.magicpatterns.com/patterns/generated-images/a156ace5-6951-434a-8bea-263470c8905b.jpg'
